import { render } from "./Coords.vue?vue&type=template&id=6afee378"
import script from "./Coords.vue?vue&type=script&setup=true&lang=js"
export * from "./Coords.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/pages/Coords.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6afee378"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6afee378', __exports__)) {
    console.log('reload')
    api.reload('6afee378', __exports__)
  }
  
  module.hot.accept("./Coords.vue?vue&type=template&id=6afee378", () => {
    console.log('re-render')
    api.rerender('6afee378', render)
  })

}


export default __exports__